import * as Yup from 'yup';

export const autopayEnrollmentFormValidationSchema = Yup.object().shape({
  enrollmentConsentOne: Yup.bool().oneOf(
    [true],
    'Selection is required to continue'
  ),
  enrollmentConsentTwo: Yup.bool().oneOf(
    [true],
    'Selection is required to continue'
  ),
});
